module.exports = __webpack_public_path__ + "static/media/emc2.f3500488.svg";